var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('header',[_c('Navigation')],1),_c('b-container',[_c('div',{staticClass:"mt-5"},[_c('alert'),_c('div',{staticClass:"mt3"},[_c('router-view')],1)],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }